<template>
  <div class="row map-canvas-parent white-box">
    <SignsExplained v-if="signExplanation" :tagId="tagId" :primaryPlaceTag="primaryPlaceTag" @close="signExplanation = false"></SignsExplained>

    <!--For recieving extra map items like group layer control-->
    <slot></slot>

    <div id="map" class="map-canvas col-12" aria-hidden="true" tabindex="-1"></div>

    <div class="map-info-btn square-btn blue-text" aria-hidden="true" v-if="hasSigns" @click="signExplanation = true;"><span>Signaturer</span></div>

    <div class="square-btn map-fullscreen-btn blue-text" aria-hidden="true" @click="openFullscreenMap();" v-show="!mapInFullscreen && !userGroupMap">
      <img alt="Udvid kortet" src="@/assets/img/expand-map.svg"/>
      <strong>Udvid</strong>
    </div>

    <div class="square-btn map-fullscreen-btn blue-text" aria-hidden="true" @click="closeFullscreenMap();" v-show="mapInFullscreen && !userGroupMap">
      <img alt="Minimer kortet" src="@/assets/img/minimize-map.svg">
      <strong>Mindre</strong>
    </div>

    <MapGps :map="map"></MapGps>

    <div class="square-btn map-fullscreen-close-btn blue-text" aria-hidden="true" @click="closeFullscreenMap();" v-show="mapInFullscreen && !userGroupMap">
      <span class="material-icons">close</span>
    </div>

    <div class="map-filter-btn square-btn blue-text" aria-hidden="true" v-if="hasFilters" v-show="mapInFullscreen" @click="$emit('toggleFullscreenFilters')"><span>Filtre</span></div>

  </div>
</template>

<script>
import L from 'leaflet';
import Map from '@/assets/Map.js'
import MarkerGenerator from '@/assets/MarkerGenerator.js'
import DataFunctions from '@/assets/DataFunctions.js'
import MapFunctions from '@/assets/MapFunctions.js'
import MapGps from '@/components/map/MapGps.vue'
import PageSettings from '@/assets/PageSettings.js'
import SignsExplained from '@/components/tag/SignsExplained.vue'
import { EventBus } from '@/main.js'
import MapPopup from '@/components/map/MapPopup.vue'
import Vue from 'vue'
const MapPopupTemplate = Vue.extend(MapPopup)
import LiveData from '@/assets/LiveData.js'

export default {
  data() {
    return {
      map: '',
      mapContent: {},
      mapContentCoords: [],
      mapInFullscreen: false,
      fitBoundsMap: true,
      stepByStepDot: false,
      hasSigns: false,
      signExplanation: false,
      liveDataTimeout: false,
      boundHasBeenFitted: false,
    }
  },
  props: {
    mapData: {
      default: false,
    },
    tagId: {
      required: false,
      default: false,
    },
    primaryPlaceTag: {
      required: false,
      default: false,
    },
    userGroupMap: {
      default: false,
    },
    startup: {
      default: false,
    },
    hasFilters: {
      default: false,
    }
  },
  components: {
    MapGps, SignsExplained
  },
  watch: {
    mapData() {
      //console.log('mapdata changed');
      this.checkForLiveData().then(() => {
        this.populateMap();
      });
    },
    startup() {
      if(this.startup == 'routeDescription') {
        this.openFullscreenMap();
      }
      else {
        this.closeFullscreenMap();
      }
    }
  },

  created() {
    EventBus.$on('goToStep', (lat, lng) => {
  		this.goToRouteDetailStep(lat, lng);
    });
    EventBus.$on('closeRouteDetails', () => {
  		this.map.map.removeLayer(this.stepByStepDot);
  		this.stepByStepDot = false;
    });
    if(['51','56','252','253','115'].indexOf(this.tagId) > -1 || ['51','56','252','253','115'].indexOf(this.primaryPlaceTag) > -1) {
      this.hasSigns = true;
    }
  },

  mounted() {
    var mapSettings = PageSettings.getMapSettings('tag', this.tagId);
    if(mapSettings != false) {
      this.fitBoundsMap = false;
      var settings = (this.$DeviceCheck.isMobile) ? {addZoomControl: false, startZoom: mapSettings.zoom, center:  mapSettings.center} : {controlPosition: 'bottomright', startZoom: mapSettings.zoom, center: mapSettings.center};
    }
    else {
      var settings = (this.$DeviceCheck.isMobile) ? {addZoomControl: false} : {controlPosition: 'bottomright'};
    }

    this.map = new Map('map', settings);

    if(this.tagId != false) {
      this.map.map.on('zoomend', e => {
        PageSettings.saveMapSettings(this.map, 'tag', this.tagId);
      });
      this.map.map.on('dragend', e => {
        PageSettings.saveMapSettings(this.map, 'tag', this.tagId);
      });
    }

    if(this.userGroupMap) {
      this.openFullscreenMap();
    }
    else if(this.startup == 'routeDescription') {
      this.openFullscreenMap();
    }
    else {
      if(this.$DeviceCheck.isMobile) {
        var width = document.getElementById('content').offsetWidth;
        var mapHeight = width/1.77;
      }
      else {
        //var height = document.getElementById('content').offsetHeight;
        var height = document.body.clientHeight;
        var mapHeight = height/2;
      }
      document.getElementById('map').style.height = mapHeight+'px';
      this.map.map.invalidateSize();
    }

    if(this.mapData != false) {
      //console.log({...this.mapData});
      this.checkForLiveData().then(() => {
        this.populateMap();
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.liveDataTimeout);
  },
  methods: {
    checkForLiveData() {
      return new Promise((resolve) => {
        //Only get liveData if parent has not gotten it already. Also an easy fix for group pages not instanciating live data by itself.
        if(LiveData.liveData == false) {
          var mapData = this.mapData.features ? this.mapData.features : this.mapData;
          var liveDataPropFound = false;
          for(var i = 0; i < mapData.length; i++) {
            for(var k in mapData[i].properties) {
              if(mapData[i].properties[k].id == 78) {
                liveDataPropFound = true;
              }
            }
          }
          if(liveDataPropFound) {
            LiveData.getLiveData().then(() => {
              resolve();
            });
            clearInterval(this.liveDataTimeout);
            this.liveDataTimeout = setInterval(() => {
              this.fitBoundsMap = false;
              LiveData.getLiveData().then(() => {
                this.populateMap();
              });
            }, 60000);
          }
          else {
            resolve();
          }
        }
        else {
          resolve();
        }
      });
    },

    populateMap() {
      this.mapContentCoords = [];

  		if(this.map.map.hasLayer(this.mapContent)) {
  			this.map.map.removeLayer(this.mapContent);
  		}
      var mapData = this.mapData.features ? this.mapData.features : this.mapData;
      if(mapData.length != undefined) {
        this.createMarkers(mapData);
      }

  		//Add calculated routes to map including startpoint markers and buffer
  		/*for(var i = 0; i < this.tagDataFiltered.features.length; i++) {
  			if(this.tagDataFiltered.features[i].geometry.type == 'LineString' && this.tagDataFiltered.features[i].properties.prop105) {
  				//Startpoint marker
  				var startPointMarker = app.generateMarker(this.tagDataFiltered.features[i], [this.tagDataFiltered.features[i].geometry.coordinates[0][1], this.tagDataFiltered.features[i].geometry.coordinates[0][0]], true, true);
  				app.generatePopup(this.tagDataFiltered.features[i], startPointMarker, mapVar, that.tagId);
  			}
  			//Coords for fitBounds

  			if(!app.showFeature(this.tagDataFiltered.features[i], {ignoreRouteProp: false})){
  				continue;
  			}
  		}

  		if(this.startup =='mapFull' && refresh != true) {
  			this.toggleMapFullscreen();
  		}

  		if(app.savedPopup != false && this.startup) {
  			for(var i in this.mapContent._layers) {
  				if(this.mapContent._layers[i].feature.id == app.savedPopup.id) {
  					if(this.mapContent._layers[i]._icon) {
  						this.mapContent._layers[i]._icon.click();
  					}
  				}
  			}
  		}
  		else {
  			app.savedPopup = false;
  		}*/
    },
    createMarkers(mapData) {
      var promises = [];
      for(var i in mapData) {
        if(mapData[i].geometry.type == 'Point') {
          let latLng = {
            lat: mapData[i].geometry.coordinates[1],
            lng: mapData[i].geometry.coordinates[0],
          }
          if(this.tagId == 231) {
            promises.push(MarkerGenerator.generateCityDevIcon(mapData[i], latLng));
          }
          else {
            promises.push(MarkerGenerator.generateMarker(mapData[i], latLng, mapData[i].opacity));
          }
        }
        else if((mapData[i].geometry.type == 'Polygon' || mapData[i].geometry.type == 'LineString') && mapData[i].lineStyle == undefined) {
          promises.push(MarkerGenerator.getLineColors(mapData[i]));
        }
      }

      Promise.all(promises).then(() => {
        this.addContentToMap(mapData);
      });
    },
    addContentToMap(mapData) {
      this.mapContent = L.geoJson(mapData, {
        onEachFeature: (feature, layer) => {
          this.createPopup(feature, layer);
          this.getCoordsForBounds(feature);
        },
        pointToLayer: (feature, latLng) => {
          return feature.marker;
        },
        filter: (feature) => {
          var showFeature = MarkerGenerator.showFeature(feature);
          return showFeature;
        },
        style: function(feature) {
          return feature.lineStyle;
        }
      }).addTo(this.map.map);
      //Only fit bounds on initial map load, not on content refresh due to livedata or filter changes
      if(this.fitBoundsMap && !this.boundHasBeenFitted) {
        this.fitBounds();
      }
    },
    createPopup(feature, layer, map, tagId) {
      layer.off('click');
    	layer.on('click', (e) => {
        var popupContent = new MapPopupTemplate({
          propsData: {
            feature: feature,
            tagId: tagId
          }
        }).$mount().$el;

        var point = this.map.map.latLngToContainerPoint(e.latlng);
        var newPoint = L.point([point.x, point.y -10]);
        var newCoords = this.map.map.containerPointToLatLng(newPoint);
        var popup = L.popup({'className': 'map-popup', closeButton: false, autoPan: false}).setLatLng(newCoords).setContent(popupContent).openOn(this.map.map);
        var px = this.map.map.project(popup._latlng); // find the pixel location on the map where the popup anchor is
        px.y -= (popup._container.clientHeight/2) + ((this.$DeviceCheck.isMobile) ? 60 : 45); // find the height of the popup container, divide by 2, subtract from the Y axis of marker location
        this.map.map.panTo(this.map.map.unproject(px),{animate: true}); // pan to new center
      });
    },
    getCoordsForBounds(feature) {
      if(feature.geometry.type == 'LineString') {
        for (var d in feature.geometry.coordinates) {
          var coords = this.$HelperFunctions.resetCoords(feature.geometry.coordinates[d]);
          coords = {lat: coords[1], lng: coords[0]};
          this.mapContentCoords.push(coords);
        }
      }
      else if(feature.geometry.type == 'Polygon') {
        for (var d in feature.geometry.coordinates[0]) {
          var coords = {lat: feature.geometry.coordinates[0][d][1], lng: feature.geometry.coordinates[0][d][0]};
          this.mapContentCoords.push(coords);
        }
      }
      else {
        var coords = {lat: feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0]};
        this.mapContentCoords.push(coords);
      }
    },
    fitBounds() {
      this.boundHasBeenFitted = true;
  		if(this.mapContentCoords.length != 0) {
  			this.map.map.fitBounds(this.mapContentCoords, {padding: [3,3]});
  		}
  	},
    openFullscreenMap() {
      this.mapInFullscreen = true;
      document.getElementsByClassName('map-canvas-parent')[0].classList.add('map-fullscreen');
      document.getElementById('map').classList.add('map-fullscreen');
      var scrollIndicator = document.getElementById('scroll-indicator');
      if(scrollIndicator != null) {
        scrollIndicator.classList.add('hidden');
      }

      this.$emit('mapInFullscreen', true);
      setTimeout(() => {
        this.map.map.invalidateSize();
      }, 300);
    },
    closeFullscreenMap() {
      this.mapInFullscreen = false;
      document.getElementsByClassName('map-canvas-parent')[0].classList.remove('map-fullscreen');
      document.getElementById('map').classList.remove('map-fullscreen');
      var scrollIndicator = document.getElementById('scroll-indicator');
      if(scrollIndicator != null) {
        scrollIndicator.classList.remove('hidden');
      }
      this.$emit('mapInFullscreen', false);
      setTimeout(() => {
        this.map.map.invalidateSize();
      }, 300);
    },
    goToRouteDetailStep(lat, lng) {
      var center = MapFunctions.calcOffset([lat,lng], this.map.map);
  		if(!this.stepByStepDot) {
  			var icon = L.divIcon({className: 'gps-circle', html: '<div class="gps-circle-dot step-by-step-dot" style="background-color: rgb(0,112,141)"></div>'});
  			this.stepByStepDot = L.marker([lat,lng], {icon: icon}).addTo(this.map.map);
  		}
  		else {
  			this.stepByStepDot.setLatLng([lat,lng]);
  		}
  		this.map.map.setView(center);
    }
  }
}
</script>

<style lang="scss" scoped>
.map-fullscreen {
	position: fixed !important;
	z-index: 800 !important;
	left: 0 !important;
	top: 50px;
	height: calc(100% - 50px) !important;
	width: 100% !important;
	margin: 0 !important;
}

/*Bullshit fix because Android keyboards suck ass*/
@media screen and (max-width: 400px) and (orientation: landscape) {
	.map-canvas {
		height: 200px !important;
		margin-top: 10px;
	}
}

/*Landscape - XS*/
@media screen and (max-width: 767px) and (orientation: landscape) {
	.map-canvas {
		height: 200px !important;
		margin-top: 10px;
	}
}

.map-canvas-parent {
  position: relative;
}

.square-btn {
  width: 36px;
	padding: 2px;
	line-height: 12px;
	z-index: 800;
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  vertical-align: middle;
  text-align: center;
	cursor: pointer;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Chrome/Safari/Opera */
	-khtml-user-select: none; /* Konqueror */
	-moz-user-select: none; /* Firefox */
	-ms-user-select: none; /* Internet Explorer/Edge */
	user-select: none; /* Non-prefixed version, currently not supported by any browser */
	-webkit-backface-visibility: hidden;
}

.square-btn strong {
	font-size: 11px;
}

.map-fullscreen-btn {
	position: absolute;
	z-index: 850;
	right: 5px;
	margin-left: 0px;
	height: 49px;
}

.map-fullscreen-btn img {
	position: relative;
	top: 2px;
	height: 30px;
	width: 30px;
}

.map-fullscreen-btn span {
	position: relative;
}

.map-fullscreen-close-btn {
  position: absolute;
	right: 5px;
	top: 5px;
	height: 36px;
}

#user-group-map-close-btn {
	top: 55px;
}

.map-info-btn, .map-filter-btn {
	position: absolute;
	z-index: 850;
	width: 90px;
	height: 35px;
	vertical-align: middle;
	display: table;
	text-align: center;
  cursor: pointer;
}

.map-info-btn span, .map-filter-btn span {
	position: relative;
	top: 1px;
	/*left: -5px;*/
	display: table-cell;
	vertical-align: middle;
}

.map-info-btn .material-icons, .map-filter-btn .material-icons {
	font-size: 26px !important;
	display: table-cell;
	vertical-align: middle;
}

.map-filter-btn {
	width: 70px;
}

/*Landscape - XS*/
@media screen and (max-width: 767px) and (orientation: landscape) {
	.map-fullscreen-btn {
		bottom: 60px;
	}
	.map-info-btn, .map-filter-btn {
		left: 5px;
		top: 5px;
	}
	.map-filter-btn {
		left: 100px;
	}
}
/*Landscape - SM*/
@media screen and (min-width: 768px) and (max-width: 991px) and (orientation: landscape) {
	.map-fullscreen-btn {
		bottom: 80px;
	}
	.map-info-btn, .map-filter-btn {
		left: 5px;
		top: 5px;
	}
	.map-filter-btn {
		left: 100px;
	}
}
/*Landscape - MD*/
@media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
	.map-fullscreen-btn {
		bottom: 135px;
	}
	.map-info-btn, .map-filter-btn {
		right: 45px;
		bottom: 7px;
	}
	.map-filter-btn {
		right: 139px;
	}
}
/*Landscape - LG*/
@media screen and (min-width: 1200px) and (orientation: landscape) {
	.map-fullscreen-btn {
		bottom: 135px;
	}
	#gps-btn, #user-group-map-gps-btn {
		bottom: 80px;
	}
	.map-info-btn, .map-filter-btn {
		right: 45px;
		bottom: 7px;
	}
	.map-filter-btn {
		right: 139px;
	}
}
/*Portrait - XS*/
@media screen and (max-width: 767px) and (orientation: portrait) {
	.map-fullscreen-btn {
		bottom: 60px;
	}
	.map-info-btn, .map-filter-btn {
		left: 5px;
		top: 5px;
	}
	.map-filter-btn {
		left: 100px;
	}
}
/*Portrait - SM*/
@media screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
	.map-fullscreen-btn {
		bottom: 80px;
	}
	.map-info-btn, .map-filter-btn {
		left: 5px;
		top: 5px;
	}
	.map-filter-btn {
		left: 100px;
	}
}
/*Portrait - MD*/
@media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: portrait) {
	.map-fullscreen-btn {
		bottom: 80px;
	}
	.map-info-btn, .map-filter-btn {
		left: 5px;
		top: 15px;
	}
	.map-filter-btn {
		left: 100px;
	}
}
/*Portrait - LG*/
@media screen and (min-width: 1200px) and (orientation: portrait) {
	.map-fullscreen-btn {
		bottom: 60px;
	}
	.map-info-btn, .map-filter-btn {
		left: 5px;
		top: 5px;
	}
	.map-filter-btn {
		left: 100px;
	}
}

/* Marker z-index */
.route-point-marker {
	z-index: 700 !important;
}

</style>
